import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import SearchMemberTextField from '../../../../pages/programs/addAttendance/registrationForm/components/searchMemberTextField';
import ParticipantDropdown from '../../../../pages/programs/addAttendance/registrationForm/components/participantDropdown';
import '../../../../css/addNewAttendance.css';

function QuickAttendanceDialog({
  open,
  close,
  data,
  handleComplete,
}) {
  const [selectedMembers, setSelectedMembers] = React.useState([]);
  const [selectedMembership, setSelectedMembership] = React.useState(null);

  React.useEffect(() => {
    if (!open) {
      setSelectedMembers([]);
      setSelectedMembership(null);
    }
  }, [open]);

  const isFamilyMembership = (membership) => (
    (membership?.membershipCategory || '').trim().toLowerCase() === 'family'
  );

  const normalizeMember = (member, membership) => ({
    ...member,
    name: member.name || `${member.firstName} ${member.lastName}`,
    membershipID: member.membershipID || membership?.membershipID,
  });

  const addMember = (member) => {
    if (!member || !member._id) return;
    setSelectedMembers((currentMembers) => {
      const alreadySelected = currentMembers.some(
        (currentMember) => currentMember._id && currentMember._id.toString() === member._id.toString(),
      );
      if (alreadySelected) return currentMembers;
      return currentMembers.concat(member);
    });
    setSelectedMembership(null);
  };

  const handleMemberFound = (membership) => {
    if (!membership) return;
    const matchedMember = membership.selectedFamilyMember || membership.familyMembersInformation?.[0];
    if (!isFamilyMembership(membership)) {
      addMember(normalizeMember(matchedMember, membership));
      return;
    }
    setSelectedMembership(membership);
  };

  const handleParticipantSelection = (event) => {
    addMember(normalizeMember(event.target.value, selectedMembership));
  };

  const completeQuickAttendance = () => {
    handleComplete(selectedMembers);
    close();
  };

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason === 'backdropClick') return;
        close();
      }}
      maxWidth="sm"
      fullWidth
      classes={{ paper: 'quickAttendance-dialog-paper' }}
    >
      <button type="button" className="quickAttendance-close" onClick={close}>
        <CloseIcon />
      </button>
      <Grid container className="quickAttendance-wrapper">
        <Grid item xs={12} className="quickAttendance-header">
          <h2>Quick Attendance</h2>
          <div>
            Total Present:
            <span>{selectedMembers.length}</span>
          </div>
        </Grid>
        <Grid item xs={12} className="quickAttendance-searchWrap">
          <SearchMemberTextField
            typeOfSearch="member"
            label="Search Membership"
            handleMemberFound={handleMemberFound}
            helperText=""
            error={false}
          />
        </Grid>
        {selectedMembership && isFamilyMembership(selectedMembership) && (
          <Grid item xs={12} className="quickAttendance-familySelect">
            <ParticipantDropdown
              id="quickAttendanceFamilyMembers"
              label="Family Members"
              name="Family Members"
              value=""
              handleChanges={handleParticipantSelection}
              helperText=""
              error={false}
              listName={selectedMembership.familyMembersInformation || []}
            />
          </Grid>
        )}
        <Grid item xs={12}>
          <Table className="quickAttendance-table">
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell align="center">Attendance Status</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {selectedMembers.map((member) => (
                <TableRow key={`${member._id || member.name}-${member.index}`}>
                  <TableCell>{member.name}</TableCell>
                  <TableCell align="center">
                    <div className="addNewAttendance-Present">Present</div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Grid>
        <Grid item xs={12} className="quickAttendance-actions">
          <button
            type="button"
            className="quickAttendance-primary"
            disabled={!selectedMembers.length}
            onClick={completeQuickAttendance}
          >
            COMPLETE QUICK ATTENDANCE
          </button>
          <button type="button" className="quickAttendance-secondary" onClick={close}>
            CANCEL
          </button>
        </Grid>
      </Grid>
    </Dialog>
  );
}

QuickAttendanceDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  handleComplete: PropTypes.func.isRequired,
  data: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    membershipID: PropTypes.string,
  })).isRequired,
};

export default QuickAttendanceDialog;
